import { HTTP_METHOD } from '../../../helper/constants';
import request from '../../request';



const parse = (res) => {
    const data = typeof res?.data === 'string' ? JSON.parse(res.data) : res?.data;
    return data?.data ?? data;
  };

export const upload = ({ type, formData, action, username }) => {
    const actionQuery = action === 'delete' ? '&action=delete' : '';
    const usernameQuery = username ? `&username=${encodeURIComponent(username)}` : '';
    return request({
      method: HTTP_METHOD.POST,
      url: `/admin/upload?type=${type}${actionQuery}${usernameQuery}`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data', bulkUploadType: type },
    });
  };

  export const history = ({ type, page = 0, size = 20 }) =>
    request({ method: HTTP_METHOD.GET, url: `/admin/upload/history?type=${type}&page=${page}&size=${size}` });

  export const downloadByRequestId = ({ requestId }) =>
    request({ method: HTTP_METHOD.GET, url: `/admin/upload/download?requestId=${requestId}`, responseType: 'blob' });
  
  export const downloadTemplate = ({ templateKey }) =>
    request({ method: HTTP_METHOD.GET, url: `/admin/template/download?templateKey=${templateKey}`, responseType: 'blob' });
  
export const historyParsed = async (args) => parse(await history(args));
export const uploadParsed = async (args) => parse(await upload(args));